import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesAutoSafe,
} from '../../../../../St/Reports/UseStyle';
import { get } from "@awesome-cordova-plugins/core/decorators/common";
import { invoicePayTypes } from "../../../../../services/invoice-service";
import { sto } from "../../../../../Context/InshData";
export default function SafesTaswyaSearchForm(props) {
    const {
        rptParams,
        onChangeData,
        changTField,
        onChangeAutoData,
        SafesOptions,
        UsersOptions,
        SafesEmp,
        branches,
        AutoOptions,
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();


    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={ sto.User_typei == 1?branches: AutoOptions?.Branches}
                        disabled={ sto.User_typei == 1?false:true}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="bill_no"
                        label="رقم الامر"
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="text"
                        name="no" value={rptParams.bill_no} onChange={onChangeData('no')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("ref-no")}
                        placeholder="رقم المرجع"

                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="text"
                        name="refno" value={rptParams.refno} onChange={onChangeData('refno')}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateFrom" label={t("from-date")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom} onChange={onChangeData('dateFrom')}
                    /></Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateTo" label={t("to-date")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo} onChange={onChangeData('dateTo')}
                    /></Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={sto.User_typei == 1? SafesOptions:SafesEmp}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("safe")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.user}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('user', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={UsersOptions}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("user")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />
                </Grid>

            </Grid>
        </React.Fragment>
    );
}
